import React, { useEffect, useState } from "react";
import { FiArrowRight, FiGift } from "react-icons/fi";
import { Link } from "react-router-dom";
import ProductCard from "../../component/products/ProductCard";
import { Product } from "../../interfaces/products/product";
import { getProducts } from "../../data-access/apis/products/productApi";
import styles from "../../styles/pages/Product/diwali-deals.module.css";
import SEO from "../../utils/seo/SEO";

const DiwaliDeals: React.FC = () => {
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    getProducts({ diwali: true })
      .then((data) => {
        if (!cancelled) {
          setProducts(
            (Array.isArray(data) ? data : [])
              .filter((product) => product.isActive)
              .sort((a, b) => b.priorityScore - a.priorityScore)
          );
        }
      })
      .catch(() => {
        if (!cancelled) setProducts([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <>
      <SEO
        title="Diwali Deals | MyOnlineShopping"
        description="Explore curated Diwali deals and festive product picks on MyOnlineShopping."
        canonicalPath="/diwali-deals"
      />

      <main className={styles.page}>
        <div className={styles.container}>
          <header className={styles.hero}>
            <div className={styles.heroCopy}>
              <div className={styles.eyebrow}><FiGift /> FESTIVE COLLECTION</div>
              <h1>Diwali Deals</h1>
              <p>Curated festive picks with clean product cards, detailed product pages and direct Amazon shopping.</p>
              <Link to="/products" className={styles.heroLink}>Explore all products <FiArrowRight /></Link>
            </div>
            <div className={styles.heroStat}>
              <strong>{loading ? "—" : products.length}</strong>
              <span>active festive picks</span>
            </div>
          </header>

          {loading ? (
            <div className={styles.grid}>
              {Array.from({ length: 8 }).map((_, index) => (
                <div className={styles.skeleton} key={index}>
                  <span />
                  <div><i /><i /><i /></div>
                </div>
              ))}
            </div>
          ) : products.length ? (
            <section>
              <div className={styles.sectionHead}>
                <div>
                  <span>HAND-PICKED FOR YOU</span>
                  <h2>Festive favourites</h2>
                </div>
                <small>{products.length} products</small>
              </div>

              <div className={styles.grid}>
                {products.map((product) => (
                  <ProductCard key={product._id} product={product} />
                ))}
              </div>
            </section>
          ) : (
            <section className={styles.empty}>
              <FiGift />
              <h2>No Diwali products yet</h2>
              <p>Active products marked as Diwali Deal from the admin panel will appear here automatically.</p>
            </section>
          )}
        </div>
      </main>
    </>
  );
};

export default DiwaliDeals;
